module.exports = __webpack_public_path__ + "img/border_text.3e639280.png";